import Settings from './reducers';

// import en dan gelijk weer exporten;
export { receivedAssortmentSettings } from './actions';
export {
  getAssortmentCategoryTitle,
  getAssortmentSettings,
  getActionableButtonText,
  getBodywork,
  getFilterButtonText,
  getFueltype,
  getMake,
  getPrice,
  getRemoveFiltersButtonText,
  getResultTitle,
  getResultTitlePlural,
  getCloseText,
  getSize,
  getSortOptionNameAsc,
  getSortOptionNameDesc,
  getSortOptionPriceAsc,
  getSortOptionPriceDesc,
  getTransmission,
  getFacetTranslation,
  getSortOptionTranslation,
  getBucketTranslation,
  getAssortmentCustomFilterHeading,
  getAssortmentCustomFilterVbmr,
  getAssortmentCustomFilterDeliverytime,
  getAssortmentCustomFilterDeliverytimeDuration,
} from './selectors';

export default Settings;
